// extracted by mini-css-extract-plugin
export default {"profile_buttons":"profilePage_profile_buttons__Apg6e","documents":"profilePage_documents__aym+C"};